export default {
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Halo!✨"])},
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bagaimana kami bisa membantu Anda hari ini? Kami di sini untuk Anda, mari mulai percakapan!"])}
  },
  "conversation": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Percakapan Saat Ini"])},
    "last_message_empty_caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Percakapan Baru..."])},
    "welcome_text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Halo! Selamat datang di ", _interpolate(_named("messengerName")), "."])},
    "enter_message_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Silakan masukkan pertanyaan Anda di bawah ini agar kami dapat menjawab pertanyaan Anda dengan cepat."])},
    "compose": {
      "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tulis pesan..."])}
    },
    "survey": {
      "post": {
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kami ingin mendengar pendapat Anda tentang percakapan ini:"])},
        "thank_you_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terima kasih atas tanggapan Anda! Ini akan membantu kami meningkatkan layanan kami untuk Anda dan yang lainnya."])}
      }
    },
    "status": {
      "sending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mengirim..."])},
      "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terkirim"])},
      "conversation_is_closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Percakapan ditutup"])}
    },
    "errors": {
      "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Percakapan tidak dapat dimuat!"])}
    }
  },
  "archived_conversations": {
    "header": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Percakapan Diarsipkan (", _interpolate(_named("count")), ")"])}
  },
  "search": {
    "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cari artikel bantuan"])},
    "no_results": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Tidak ada hasil untuk \"", _interpolate(_named("query")), "\""])},
    "no_results_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Silakan coba kata kunci lain"])}
  },
  "channels": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bagaimana Anda ingin berhubungan hari ini?"])},
    "whatsapp": {
      "card_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirim pesan WhatsApp"])},
      "qr_code_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pindai dengan aplikasi kamera atau klik kode QR untuk memulai percakapan."])},
      "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buka WhatsApp"])},
      "number_undefined_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomor tidak ditentukan."])},
      "initial_text_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Halo tim! Saya ingin tahu..."])}
    }
  },
  "agents": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "availability": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tim dukungan kami online"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "status": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Online"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offline"])},
      "away": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tidak Aktif"])}
    },
    "is_typing": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("agentName")), " sedang mengetik..."])}
  },
  "forms": {
    "fields": {
      "_CONTACT_NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nama"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_CONTACT_EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["namadepan", "@", "perusahaan.com..."])}
      },
      "_CONTACT_PHONE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telepon"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(contoh: 081234567890)"])}
      },
      "_SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subjek"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_INITIAL_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pertanyaan"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesan"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    },
    "types": {
      "PRE_CHAT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isi formulir di bawah ini, agar kami bisa mengenal Anda 😄"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirim pesan Anda"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kami akan menghubungkan Anda dengan salah satu anggota tim kami!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ups, percakapan tidak dapat dimulai. Bisakah Anda mencoba lagi?"])}
      },
      "CONTACT_DETAILS": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isi formulir di bawah ini, agar kami tetap bisa berkomunikasi"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirim"])},
        "dismiss-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nanti saja"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terima kasih atas email Anda."])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ups, formulir tidak dapat dikirimkan"])}
      },
      "EMAIL": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hubungi Kami"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isi formulir di bawah ini untuk menghubungi tim dukungan pelanggan kami"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirim pesan Anda"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulir email telah terkirim!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ups, email tidak dapat dikirimkan. Silakan coba lagi."])}
      },
      "WHATSAPP_CONTACT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mulai percakapan WhatsApp"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Perkenalkan diri dan ajukan pertanyaan Anda agar kami dapat membantu Anda segera."])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirim pesan Anda"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulir kontak WhatsApp telah terkirim!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ups, formulir kontak WhatsApp tidak dapat dikirimkan. Bisakah Anda mencoba lagi?"])}
      }
    }
  },
  "mailform": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulir Email"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isi formulir di bawah ini untuk menghubungi tim dukungan pelanggan kami"])},
    "fields": {
      "NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nama"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subjek"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "QUESTION": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pertanyaan"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "UPLOAD": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "add_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tambahkan lampiran"])}
      },
      "TOPIC": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Topik"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilih..."])}
      }
    },
    "notifications": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulir email telah terkirim!"])},
      "errors": {
        "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sayangnya, formulir tidak dapat dikirim. Bisakah Anda mencoba lagi?"])}
      }
    },
    "submit_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirim pesan"])}
  },
  "common": {
    "buttons": {
      "start_new_conversation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mari memulai percakapan"])},
      "show_archived_conversations": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Tampilkan percakapan diarsipkan (", _interpolate(_named("count")), ")"])},
      "go_to_mailform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kirim email sebagai gantinya"])},
      "go_back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kembali"])}
    },
    "page_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["💬 Pesan Baru \"", _interpolate(_named("message")), "\""])},
    "toast": {
      "generic_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ups, ada masalah!"])},
      "message_sent_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terjadi kesalahan saat mengirim pesan"])},
      "giphy_no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tidak ada gambar Giphy yang dapat ditemukan."])}
    },
    "errors": {
      "upload_too_large": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ukuran file tidak boleh melebihi 5MB"])},
      "upload_file_type_disallowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jenis file ini tidak diizinkan"])}
    }
  },
  "gdpr": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persetujuan Cookie PDP"])},
    "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Halo! Kami ingin berbicara dengan Anda. Namun, berdasarkan Peraturan Umum Perlindungan Data (PDP) UE, kami memerlukan persetujuan Anda terlebih dahulu untuk penggunaan informasi pribadi (misalnya nama dan alamat email Anda). Apakah Anda setuju jika:<br><br>1) Kami akan menyimpan informasi pribadi Anda sehingga kami bisa melanjutkan percakapan jika kami berbicara lagi;<br><br>2) Kami mungkin mengirimkan email untuk mengikuti percakapan kami di sini;<br><br>3) Kami mungkin mengirimkan email tentang layanan dan promosi kami yang akan datang.<br>"])},
    "disapprove_body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tidak masalah. Anda dapat melihat syarat dan kebijakan kapan saja dan memberikan persetujuan untuk melanjutkan"])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ya, tidak masalah"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tidak, tidak hari ini"])}
  },
  "powered_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ditenagai oleh Grasp"])}
}